import type { Style, StyleSource } from "../shared/types";

type ApprovedCalibration = {
  sourceIds: string[];
  approvalSha256: string;
  appearanceText: string;
  motionText: string;
  cameraOptions: Record<string, string>;
  model: string;
};

export function approvedCalibration(style: Style): ApprovedCalibration | null {
  const value = style.provenance.approvedCalibration;
  if (!value || typeof value !== "object") return null;
  const candidate = value as Partial<ApprovedCalibration>;
  if (!Array.isArray(candidate.sourceIds) || candidate.sourceIds.length === 0 || !candidate.sourceIds.every((id) => typeof id === "string")) return null;
  return candidate as ApprovedCalibration;
}

export function approvedSources(style: Style): StyleSource[] {
  const calibration = approvedCalibration(style);
  if (!calibration) return [];
  const byId = new Map(style.sources.map((source) => [source.id, source]));
  return calibration.sourceIds.map((id) => byId.get(id)).filter((source): source is StyleSource => Boolean(source));
}

export function historicalSources(style: Style): StyleSource[] {
  const approvedIds = new Set(approvedSources(style).map((source) => source.id));
  return style.sources.filter((source) => !approvedIds.has(source.id));
}

export function showcaseSource(style: Style): StyleSource | undefined {
  return approvedSources(style)[0] ?? style.sources.find((source) => source.previewUrl || source.mediaUrl || source.ad?.posterUrl) ?? style.sources[0];
}
